export { default } from './ManufacturedHomeContactsBanner';
